export const queryKey = {
  /**
   * ENABLE-895: 화면 인스턴스별 키 — 진입(새 instanceId)마다 fresh fetch.
   * 공유 queryClient가 staleTime Infinity라 키를 공유하면 웹뷰 등 외부에서
   * 등록한 배송지가 재진입 시 반영되지 않음 (native는 진입마다 재조회).
   */
  addresses: (instanceId: string) => ['addresses', instanceId],
  alarmSettings: () => ['alarmSettings'],
  beautyInfo: () => ['beautyInfo'],
  marketingAlarmSettings: () => ['marketingAlarmSettings'],
  pocList: () => ['pocList'],
  productCategories: () => ['productCategories'],
  productCategoryMeasureValues: (productCategorySno?: number) => [
    'productCategoryMeasureValues',
    productCategorySno,
  ],
};
